import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface ErrorEntry {
  wrName: string;
  timestamp: string;
  errorResolved: boolean;
  errorName: string;
  errorLevel: string;
  serviceGuideLink: string;
}

const errors: ErrorEntry[] = [
  {
    wrName: 'WR-001',
    timestamp: '2024-03-15 14:30:00',
    errorResolved: true,
    errorName: 'Battery Overheating',
    errorLevel: 'Critical',
    serviceGuideLink: 'https://service.guide/battery-overheating',
  },
  {
    wrName: 'WR-002',
    timestamp: '2024-03-15 13:45:00',
    errorResolved: false,
    errorName: 'Communication Error',
    errorLevel: 'Warning',
    serviceGuideLink: 'https://service.guide/comm-error',
  },
  {
    wrName: 'WR-003',
    timestamp: '2024-03-15 12:20:00',
    errorResolved: true,
    errorName: 'Inverter Fault',
    errorLevel: 'Critical',
    serviceGuideLink: 'https://service.guide/inverter-fault',
  },
  {
    wrName: 'WR-001',
    timestamp: '2024-03-15 11:15:00',
    errorResolved: true,
    errorName: 'Grid Connection Lost',
    errorLevel: 'Warning',
    serviceGuideLink: 'https://service.guide/grid-connection',
  },
  {
    wrName: 'WR-004',
    timestamp: '2024-03-15 10:30:00',
    errorResolved: false,
    errorName: 'Battery Low Voltage',
    errorLevel: 'Critical',
    serviceGuideLink: 'https://service.guide/battery-voltage',
  },
  {
    wrName: 'WR-002',
    timestamp: '2024-03-15 09:45:00',
    errorResolved: true,
    errorName: 'Temperature Sensor Error',
    errorLevel: 'Warning',
    serviceGuideLink: 'https://service.guide/temp-sensor',
  },
  {
    wrName: 'WR-003',
    timestamp: '2024-03-15 08:30:00',
    errorResolved: false,
    errorName: 'DC Voltage High',
    errorLevel: 'Critical',
    serviceGuideLink: 'https://service.guide/dc-voltage',
  },
  {
    wrName: 'WR-001',
    timestamp: '2024-03-15 07:15:00',
    errorResolved: true,
    errorName: 'Fan Failure',
    errorLevel: 'Warning',
    serviceGuideLink: 'https://service.guide/fan-failure',
  },
  {
    wrName: 'WR-004',
    timestamp: '2024-03-15 06:00:00',
    errorResolved: true,
    errorName: 'Ground Fault',
    errorLevel: 'Critical',
    serviceGuideLink: 'https://service.guide/ground-fault',
  },
  {
    wrName: 'WR-002',
    timestamp: '2024-03-15 05:30:00',
    errorResolved: false,
    errorName: 'Battery Communication Error',
    errorLevel: 'Warning',
    serviceGuideLink: 'https://service.guide/battery-comm',
  },
];

export function WhiteLabelErrors() {
  return (
    <div className="rounded-lg border bg-card p-6">
      <h2 className="mb-4 text-xl font-semibold">Error List (Last 10 Items)</h2>
      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Inverter Name</TableHeader>
              <TableHeader>Timestamp</TableHeader>
              <TableHeader>Resolved</TableHeader>
              <TableHeader>Name</TableHeader>
              <TableHeader>Level</TableHeader>
              <TableHeader>Service Guide</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {errors.map((error) => (
              <TableRow key={`${error.wrName}-${error.timestamp}`}>
                <TableCell>{error.wrName}</TableCell>
                <TableCell>{error.timestamp}</TableCell>
                <TableCell>{error.errorResolved ? 'Yes' : 'No'}</TableCell>
                <TableCell>{error.errorName}</TableCell>
                <TableCell>{error.errorLevel}</TableCell>
                <TableCell>
                  <a
                    href={error.serviceGuideLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Link
                  </a>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
